import { SchedulesTypes } from '@mode/shared/contract-common';
import { Observable } from 'rxjs';
import { PaginationTypes } from '@mode/shared/contract-common';
import { Sort } from '@angular/material/sort';

export abstract class SchedulesFacade {
  abstract readonly schedules$: Observable<Array<SchedulesTypes.Schedule> | null>;
  abstract readonly schedulesPagination$: Observable<PaginationTypes.Pagination>;
  abstract readonly openScheduleModal$: Observable<{ token: string; reportToken: string }>;
  abstract readonly isSchedulesLoading$: Observable<boolean>;
  abstract readonly query$: Observable<string>;
  abstract readonly filters$: Observable<string>;
  abstract readonly sort$: Observable<string>;
  abstract readonly hasDeletedSchedules$: Observable<boolean>;
  abstract readonly scheduleIntervalThreshold$: Observable<string | null>;
  abstract readonly availableIntervals$: Observable<string[]>;

  public abstract loadSchedules(page?: number, query?: string, filters?: string, sort?: string): void;

  public abstract deleteSchedule({ token, deleteForm }: SchedulesTypes.Schedule): void;

  public abstract openScheduleModal({ token, reportToken }: SchedulesTypes.Schedule): void;
  public abstract openWorkspaceSettingScheduleModal({ token, reportToken }: SchedulesTypes.Schedule): void;

  public abstract bulkDeleteSchedule(payload: SchedulesTypes.BulkDeleteResource): void;
  public abstract updateScheduleSort(sortData: Sort): void;

  public abstract updateSchedulesFilter(filter: string): void;
  public abstract loadScheduleIntervalThreshold(accountID: string): void;
  public abstract updateScheduleIntervalThreshold(accountID: string, interval: string): void;
}
